export default {"src":"/_next/static/media/course-heading-icon.965b2b82.svg","height":92,"width":78,"blurWidth":0,"blurHeight":0};